import { object } from "prop-types";

const UPDATE_ALERT_MSG="updateAlertMsg";
const UPDATE_ALERT_STATUS="updateAlertStatus";
const initialState = {
    status:1,
    msg:''            //弹窗文案
}
const reducer = function(state = initialState, action) {
    let { type, params } = action;
    switch (type) {
        case UPDATE_ALERT_MSG:return Object.assign({},state,{
            msg:params
        })
        case UPDATE_ALERT_STATUS:return Object.assign({},state,{
            status:params
        })
        default: return state;
    }
}

export {
    reducer as default,
    initialState as alertInitialState
}
